import gql from 'graphql-tag';

export default gql`
  mutation shareVendorIntegration($input: ShareVendorIntegrationInput) {
    shareVendorIntegration(input: $input)
  }
`;
